var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex center-xs" }, [
    _c(
      "div",
      {
        staticClass: "progress-section space-top flex",
        staticStyle: { width: "100%" },
      },
      [
        _c("h3", { staticClass: "progress-percentage maison-typo" }, [
          _vm._v(_vm._s(_vm.progressPercentage) + "%"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "progress-bar-full space-left-1" }, [
          _c("span", {
            staticClass: "progress-bar-progress",
            style: "width: " + _vm.progressPercentage + "%;",
          }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }